module.exports = __webpack_public_path__ + "media/images/DataPortal-091b50a72f78559e16da88ccca60a285.svg";